module.exports = __webpack_public_path__ + "img/MaskGroup2.330b33a1.svg";